import React from 'react';
import { Redirect } from 'react-router-dom';
import { home } from 'userRoutes';

const Login = () => {
  return <Redirect to={home} />;
};

export default Login;
